/**
 * PropertyTimezoneProvider
 * Provides the property's IANA timezone string to the payment/lease component tree.
 * Callers resolve the timezone via useUnitTimezone(unitId) (see hooks/useUnitTimezone.ts) —
 * a batched, cached lookup by unit ID — rather than requiring unit.state to have been
 * threaded through whatever payload built the page (issue #910).
 *
 * Keeps the context intentionally lightweight — no state, no effects,
 * just a string passed down once from the page that owns the lease.
 */

import { type ReactNode } from 'react';
import { PropertyTimezoneContext } from './propertyTimezone.context.js';

interface PropertyTimezoneProviderProps {
  timezone: string;
  children: ReactNode;
}

export function PropertyTimezoneProvider({ timezone, children }: PropertyTimezoneProviderProps) {
  return (
    <PropertyTimezoneContext.Provider value={{ timezone }}>
      {children}
    </PropertyTimezoneContext.Provider>
  );
}
